const LoadingSpinner = () => {
  return (
    <div className=" flex h-full w-full backdrop bg-primary bg-opacity-50">
      <div className="fixed flex-col inset-0 z-20 flex justify-center items-center h-screen w-screen backdrop">
        <div className="border-t-4 border-l-2 border-white rounded-full animate-spin w-12 h-12"></div>
        <div className=" font-semibold text-white text-lg mt-3">
          Loading . . .
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
